import config from "../config";
import en from './en.json'
import hy from './hy.json'
import ru from './ru.json'

export default {
    [config.localeValues.english]: en,
    [config.localeValues.armenian]: hy,
    [config.localeValues.russian]: ru,
};
